<!-- Projection slot — primary buttons / custom controls before the overflow. -->
<ng-content></ng-content>

@if (hasOverflow()) {
  <tw-dropdown placement="bottom" [open]="open()" (openChange)="onOpenChange($event)">
    <button twDropdownTrigger type="button" class="tw-page-header-actions__overflow-trigger"
      [attr.aria-label]="overflowLabel()">
      <svg viewBox="0 0 16 16" width="17" height="17" aria-hidden="true" focusable="false">
        <circle cx="8" cy="3" r="1.5" fill="currentColor" />
        <circle cx="8" cy="8" r="1.5" fill="currentColor" />
        <circle cx="8" cy="13" r="1.5" fill="currentColor" />
      </svg>
    </button>
    <tw-dropdown-menu>
      @for (item of visibleItems(); track $index; let i = $index) {
        @if (isDivider(item)) {
          <hr aria-hidden="true" style="border:0;border-top:1px solid var(--twist-color-border);margin:var(--twist-spacing-1) var(--twist-spacing-2);" />
        } @else {
          <tw-dropdown-item
            [disabled]="!!item.disabled"
            [class.tw-page-header-actions__danger]="item.danger"
            (selected)="onItemSelected(item, i)">
            @if (item.icon) {
              <span class="tw-page-header-actions__item-icon" aria-hidden="true">{{ item.icon }}</span>
            }
            <span class="tw-page-header-actions__item-label">{{ labelFor(item, i) }}</span>
            @if (item.hint) {
              <span class="tw-page-header-actions__hint">{{ item.hint }}</span>
            }
          </tw-dropdown-item>
        }
      }
    </tw-dropdown-menu>
  </tw-dropdown>
}
